export default function Marquee({ items, separator = "  /  " }) {
  const seq = items.join(separator);
  const content = seq + separator;
  return (
    <div data-testid="marquee" className="overflow-hidden py-8 md:py-12 border-y hairline select-none">
      <div className="marquee-track">
        <span className="font-display font-500 uppercase tracking-[0.08em] text-2xl md:text-4xl pr-16">
          {content}
        </span>
        <span className="font-display font-500 uppercase tracking-[0.08em] text-2xl md:text-4xl pr-16" aria-hidden="true">
          {content}
        </span>
      </div>
    </div>
  );
}
